(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports(
            require('./search.js'),
            require('../props/channel.js')
        );
    } else {
        RivalIQ.metric.access = exports(
            RivalIQ.metric.search,
            RivalIQ.props
        );
    }

    function exports(search, channel) {

        // Returns true if this metric can be accessed by this plan
        function planAccess(metric, plan) {
            const feature = search.getPropertyValue(metric, 'requiredPlanFeature');
            return (feature ? plan[feature] : true);
        }

        function betaAccess(metric, betas) {
            const beta = search.getPropertyValue(metric, 'requiredBeta');
            return (beta ? betas[beta] : true);
        }

        // Returns true if this metric can be accessed given the current tokens
        // associated w/ the account
        function tokenAccess(metric, props) {
            const source = search.getPropertyValue(metric, 'source');
            return !channel.channelRedacted(props || metric, source);
        }

        /*
         * Returns true if the metric's channel has not been hidden
         */
        function channelAccess(metric, props) {
            const source = search.getPropertyValue(metric, 'source');
            return channel.channelAccess(props || metric, source);
        }

        return {
            plan: planAccess,
            beta: betaAccess,
            token: tokenAccess,
            channel: channelAccess
        };
    }
})();
